import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { rootReducers } from './store/index.reducers';
import { LoginEffects } from './store/login/login.effects';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from './utils/interceptor';
import { ConfigEffects } from './store/config/config.effects';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ClientActivitiesEffects } from './store/client-activities/client-activities.effects';
import { CourierActivitiesEffects } from './store/courier-activities/courier-activities.effects';
import { PackageWarehouseEffects } from './store/package-warehouse/package-warehouse.effects';
import { ConsumableWarehouseEffects } from './store/consumable-warehouse/consumable-warehouse.effects';
import { PuntoPosteManagementEffects } from './store/punto-poste-management/punto-poste-management.effects';
import { CertificaEmailEffects } from './store/certifica-email/certifica-email.effects';
import { LoginOtpEffects } from './store/login-otp/login-otp.effects';
import { CertificaCellulareEffects } from './store/certifica-cellulare/certifica-cellulare.effects';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideEffects([ConfigEffects, LoginEffects, ClientActivitiesEffects, CourierActivitiesEffects, PackageWarehouseEffects, ConsumableWarehouseEffects,
      PuntoPosteManagementEffects, CertificaEmailEffects, LoginOtpEffects, CertificaCellulareEffects]),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideStore(rootReducers),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: 'it',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};
